export default __webpack_public_path__ + "static/media/Unofficial_JavaScript_logo_2.acc4642f.svg";